import { useSelector } from "react-redux";
import { Outlet } from "react-router-dom";
import { selectAbilities } from "../../core/auth/authSlice";
import {
  AbilityContext,
  defineAppAbilities,
} from "../../core/routes/abilities/AbilityContext";
import { WebSocketProvider } from "../../shared/socket-provider/WebSocketProvider";

function AuthRouteComponent() {
  const abilities = useSelector(selectAbilities);
  // console.log(abilities)
  const ability = defineAppAbilities(abilities);
  // console.log(ability)
  // const canReadMember = ability.can('read', 'Member')
  // console.log(canReadMember)
  return (
    <AbilityContext.Provider value={ability}>
      <WebSocketProvider>
        <Outlet />
      </WebSocketProvider>
    </AbilityContext.Provider>
  );
}

export default AuthRouteComponent;
